import React from 'react';
import { TimePicker } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';
import { uniq, isEmpty } from 'lodash';

export function TimePickerControl({ name, settings, onBlur, onChange, disabledTimes, ...props }) {
  const disabledMinutes = selectedHour => {
    if (!isEmpty(disabledTimes)) {
      // Find the disabled minutes for the selected hour
      const selectedHourDisabledMinutes = disabledTimes
        .filter(time => time.hours() === selectedHour)
        .map(time => time.minutes());

      // Create an array of unique disabled minutes for the selected hour
      const uniqueDisabledMinutes = uniq([...selectedHourDisabledMinutes]);
      return uniqueDisabledMinutes;
    }

    return [];
  };

  return (
    <TimePicker
      allowClear={false}
      minuteStep={15}
      format={'HH:mm'}
      inputReadOnly={true}
      onBlur={() => onBlur({ target: { name } })}
      onChange={value => {
        // Check if an hour is selected
        if (value && value.hours()) {
          // Check if the selected minute is disabled
          const selectedDisabledMinutes = disabledMinutes(value.hours());
          if (selectedDisabledMinutes.includes(value.minutes())) {
            // Create a new moment object with null hour and minute to clear the field
            value = moment({ hour: null, minute: null });
          }
        }
        onChange({
          target: { name, value },
        });
      }}
      getPopupContainer={trigger => trigger.parentNode}
      {...(!isEmpty(disabledTimes) ? { disabledMinutes: selectedHour => disabledMinutes(selectedHour) } : {})}
      {...settings}
      {...props}
    />
  );
}

TimePickerControl.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  settings: PropTypes.object,
  hasError: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabledTimes: PropTypes.arrayOf(PropTypes.instanceOf(moment)),
};
